import { mapGetters } from 'vuex';
export const themeMixin = {
  computed: {
    ...mapGetters({
      design: 'design',
    }),

    isLayoutCentered() {
      return this.design.align == 'center';
    },

  themeStyle() {
      // if( this.isLayoutCentered ) return 'color:white';
      return null;
    },

    isDarkMode() {
      if (this.poll.options.darkMode) return true;
      return false;
    },

    textColor() {
      if (this.isDarkMode) {
        return 'text-white';
      }
      return 'text-dark-grey';
    },

    cssMobileTheme() {
      if (this.isDarkMode) {
        return 'dark-mobile-mode';
      } else {
        return 'light-mobile-mode';
      }
    },

    cssTheme() {
      var isFirefox = typeof InstallTrigger !== 'undefined';
      console.log({ isFirefox });
      if (this.isDarkMode) {
        if (isFirefox) {
          return 'dark-mode dark-mode-bg-ff';
        }
        return 'dark-mode dark-mode-bg';
      }
      if (isFirefox) {
        return 'light-mode light-mode-bg-ff';
      }
      return 'light-mode light-mode-bg';
    }
  },
};
